import { put } from "../../service/api";

const UpdateVatMerchant = async (data,merchantId,vatMerchantId) => {
    try {
        const response = await put(`/merchant/${merchantId}/vatMerchant/${vatMerchantId}`,data);
        return response.data;
    } catch (error) {
        console.error('Error UpdateVatMerchant:', error);
        throw error;
    }
};

export default UpdateVatMerchant;